<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Price.FCLAdditionalFeeMaintenance')"
    width="1140px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="surcharge-fcl-form-dialog details-view"
  >
    <div class="main-content">
      <div style="margin-bottom: 10px;">
        <el-button no="onSubmit" type="primary" @click="onSubmit">{{ $t('Pricing.Save') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
      </div>
      <div style="width: fit-content">
        <div style="display: flex">
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item ref="pol" :label="$t('Pricing.POL')">
                <cargo-advance-select
                  no="pol"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  filterable
                  :show-custom-label-in-option="true"
                  :default-value="price.pol"
                  @parentCallBack="p=>{price.pol=p.value}"
                />
              </el-form-item>
              <el-form-item ref="pod" :label="$t('Pricing.POD')">
                <cargo-advance-select
                  no="pod"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  filterable
                  :show-custom-label-in-option="true"
                  :default-value="price.pod"
                  @parentCallBack="p=>{price.pod=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Direct')">
                <!--                <el-checkbox ref="direct" v-model="price.direct" no="direct" :label="$t('Pricing.Direct')"/>-->
                <cargo-advance-select
                  no="directType"
                  filterable
                  :cache="false"
                  :clearable="false"
                  tag-name="chineseName"
                  tag-value="code"
                  :filter-tag-names="['code','chineseName']"
                  :static-options="directTypeList"
                  :default-value="price.directType"
                  @parentCallBack="p=>{price.directType=p.code}"
                />
              </el-form-item>
              <el-form-item v-show="price.directType === 3" ref="via" :required="price.directType === 3" :label="$t('Pricing.Via')">
                <cargo-advance-select
                  no="via"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.via"
                  filterable
                  @parentCallBack="p=>{price.via=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.TradeLane')">
                <cargo-advance-select
                  no="region"
                  :select-type="selectTypeNames.basic_data_Region"
                  filterable
                  :custom-label="(item)=>`${item.name}`"
                  :show-custom-label-in-option="true"
                  :default-value="price.region"
                  @parentCallBack="p=>{price.region=p.value}"
                />
              </el-form-item>
              <el-form-item ref="eqType" required :label="$t('Pricing.EqType')">
                <cargo-advance-select
                  no="eqType"
                  :select-type="selectTypeNames.basic_data_EQType"
                  tag-name="code"
                  filterable
                  :clearable="false"
                  :default-value="price.eqType"
                  @parentCallBack="p=>{price.eqType=p.value}"
                />
              </el-form-item>
              <el-form-item ref="currency" required :label="$t('Pricing.Currency')">
                <cargo-advance-select
                  no="currency"
                  :select-type="selectTypeNames.basic_data_Currency"
                  filterable
                  :clearable="false"
                  :default-value="price.currency"
                  @parentCallBack="p=>{price.currency=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Carrier')">
                <cargo-advance-select
                  no="carrier"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true}"
                  :custom-label="(item)=> item.cmpIdx > 0 ? `[${item.shortName}]${item.chineseName}` : ''"
                  :show-custom-label-in-option="true"
                  :default-value="price.carrier"
                  @parentCallBack="p=>{price.carrier=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.BookingAgent')">
                <cargo-advance-select
                  no="bookingAgent"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{bookingAgent:true}"
                  :custom-label="(item)=>`${item.chineseName}`"
                  :show-custom-label-in-option="true"
                  :default-value="price.bookingAgent"
                  @parentCallBack="p=>{price.bookingAgent=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item ref="payment" required :valid="$t('Message.PleaseSelect')" :label="$t('Pricing.PaymentTerm')">
                <cargo-advance-select
                  no="payment"
                  :select-type="selectTypeNames.local_cache_PriceConstant$PAYMENT_TERMS"
                  filterable
                  :default-value="price.payment"
                  @parentCallBack="p=>{price.payment=p.value}"
                />
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="price.vat" no="vat">{{ $t('Pricing.VatIncluded') }}</el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('Pricing.COST_VAT')">
                <div style="display: flex">
                  <el-input
                    v-model="costVat"
                    no="costVat"
                    :disabled="price.vat"
                    type="number"
                    style="width: 100%"
                    @change="costVatChange"
                  />
                  <label> %</label>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.SELL_VAT')">
                <div style="display: flex">
                  <el-input
                    v-model="sellVat"
                    no="sellVat"
                    type="number"
                    :disabled="price.vat"
                    style="width: 100%"
                    @change="sellVatChange"
                  />
                  <label> %</label>
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.GenerateCharge')">
                <el-checkbox v-model="price.generateCharge" no="generateCharge" />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item ref="chargeScaleCode" required :valid="$t('FileHistory.PlsInput')" :label="$t('Pricing.FeeName')">
                <cargo-advance-select
                  no="chargeScaleCode"
                  filterable
                  :cache="false"
                  tag-name="zhName"
                  tag-value="scaleCode"
                  :filter-tag-names="['zhName','scaleCode', 'enName']"
                  :static-options="chargeItems"
                  :default-value="price.chargeScaleCode"
                  @parentCallBack="changeSurchargeScaleCode"
                />
              </el-form-item>
              <el-form-item ref="chargeType" required :valid="$t('FileHistory.PlsInput')" :label="$t('Pricing.ChargeType')">
                <cargo-advance-select
                  no="chargeType"
                  :static-options="chargeTypes"
                  tag-name="label"
                  tag-value="value"
                  :default-value="price.chargeType"
                  @parentCallBack="p=>{price.chargeType=p.value}"
                />
              </el-form-item>
              <el-form-item ref="freightType" required :label="$t('Pricing.PriceType')">
                <cargo-advance-select
                  no="freightType"
                  :static-options="priceTypes"
                  tag-value="code"
                  :default-value="price.freightType"
                  :clearable="false"
                  @parentCallBack="p=>{price.freightType=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.ChargeUnit')">
                <cargo-advance-select
                  no="unit"
                  filterable
                  :select-type="selectTypeNames.basic_data_ChargeUnit"
                  callback-method-type="value"
                  tag-name="chineseName"
                  tag-value="code"
                  :default-value="price.unit"
                  @parentCallBack="p=>{price.unit=p}"
                />
              </el-form-item>
              <el-form-item label="20'">
                <pair-numeric-stepper
                  ref="valid20"
                  no="cost20"
                  :required="false"
                  :one="price.cost20"
                  :one-prompt="$t('Pricing.Cost')"
                  :two-prompt="$t('Pricing.Sell')"
                  :two="price.sum20"
                  @onChangeOne="p=>{price.cost20=p}"
                  @onChangeTwo="p=>{price.sum20=p}"
                />
              </el-form-item>
              <el-form-item label="40'">
                <pair-numeric-stepper
                  ref="valid40"
                  no="cost40"
                  :required="false"
                  :one="price.cost40"
                  :one-prompt="$t('Pricing.Cost')"
                  :two-prompt="$t('Pricing.Sell')"
                  :two="price.sum40"
                  @onChangeOne="p=>{price.cost40=p}"
                  @onChangeTwo="p=>{price.sum40=p}"
                />
              </el-form-item>
              <el-form-item label="40'HC">
                <pair-numeric-stepper
                  ref="validHC"
                  no="costhc"
                  :required="false"
                  :one="price.costhc"
                  :one-prompt="$t('Pricing.Cost')"
                  :two-prompt="$t('Pricing.Sell')"
                  :two="price.sumhc"
                  @onChangeOne="p=>{price.costhc=p}"
                  @onChangeTwo="p=>{price.sumhc=p}"
                />
              </el-form-item>
              <el-form-item label="20'NOR">
                <pair-numeric-stepper
                  ref="valid20nor"
                  no="cost20nor"
                  :required="false"
                  :one="price.cost20nor"
                  :one-prompt="$t('Pricing.Cost')"
                  :two-prompt="$t('Pricing.Sell')"
                  :two="price.sum20nor"
                  @onChangeOne="p=>{price.cost20nor=p}"
                  @onChangeTwo="p=>{price.sum20nor=p}"
                />
              </el-form-item>
              <el-form-item label="40'NOR">
                <pair-numeric-stepper
                  ref="valid40nor"
                  no="cost40nor"
                  :required="false"
                  :one="price.cost40nor"
                  :one-prompt="$t('Pricing.Cost')"
                  :two-prompt="$t('Pricing.Sell')"
                  :two="price.sum40nor"
                  @onChangeOne="p=>{price.cost40nor=p}"
                  @onChangeTwo="p=>{price.sum40nor=p}"
                />
              </el-form-item>
              <el-form-item label="45'">
                <pair-numeric-stepper
                  ref="valid45"
                  no="cost45"
                  :required="false"
                  :one="price.cost45"
                  :one-prompt="$t('Pricing.Cost')"
                  :two-prompt="$t('Pricing.Sell')"
                  :two="price.sum45"
                  @onChangeOne="p=>{price.cost45=p}"
                  @onChangeTwo="p=>{price.sum45=p}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.UnitPrice')">
                <pair-numeric-stepper
                  ref="validCasePrice"
                  no="costCasePrice"
                  :required="false"
                  :one="price.costCasePrice"
                  :one-prompt="$t('Pricing.Cost')"
                  :two-prompt="$t('Pricing.Sell')"
                  :two="price.casePrice"
                  @onChangeOne="p=>{price.costCasePrice=p}"
                  @onChangeTwo="p=>{price.casePrice=p}"
                />
              </el-form-item>
              <el-form-item ref="beginDate" required :valid="$t('FileHistory.PlsInput')" :label="$t('Pricing.BeginDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.beginDate"
                    no="beginDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item ref="endDate" required :label="$t('Pricing.EndDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.endDate"
                    no="endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.Remarks')">
                <el-input
                  v-model="price.remarks"
                  no="remarks"
                  type="textarea"
                  :maxlength="255"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="section form-column" style="width: 500px;">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item :label="$t('Pricing.Dangerous')">
                <el-checkbox v-model="price.dangerous" no="dangerous" style="width: 190px;" />
              </el-form-item>
              <el-form-item :label="$t('Pricing.DangerousClass')">
                <cargo-advance-select
                  no="classification"
                  filterable
                  :clearable="false"
                  :disabled="!price.dangerous"
                  :static-options="dangerousClassData"
                  multiple
                  style="width: 200px"
                  :custom-label="(item)=>`${item.classification}`"
                  :show-custom-label-in-option="true"
                  tag-value="classification"
                  :default-multiple-value="dangerousClass"
                  @parentCallBack="p=>{dangerousClass=[...p.value]}"
                />
              </el-form-item>
            </el-form>
            <div v-show="!isCp && !isNew" style="margin-right: 10px;">
              <cargo-ag-grid
                key="22080103"
                config-module="22080103"
                :grid-params.sync="file.gridParams"
                :grid-options="file.gridOptions"
                :column-defs="file.columnDefs"
                :row-data="file.rowData"
                style="flex: 1"
                @gridReady="params=>{file.gridApi=params.api}"
              />
              <div style="text-align: right;margin-top: 10px;">
                <el-button no="visible" type="primary" @click="file.cloudFile.visible=true">{{ $t('FileHistory.Upload') }}</el-button>
                <el-button no="delFileEventHandler" :disabled="!hasSelectFile" type="danger" style="margin-right: 10px" @click="delFileEventHandler()">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="file.cloudFile.visible"
      :job="price"
      :lob="file.cloudFile.lob"
      :should-encode-uuid="true"
      @uploadDone="fileUploadSuccess"
    />
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import NumericStepper from '@/views/cargo/v0/Price/components/numericStepper'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import { saveSurchargeFCL } from '@/api/price/surchargeFcl'
import { getIMDGClassification } from '@/api/sysManage/imdgCode'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import PairNumericStepper from '@/views/cargo/v0/Price/components/pairNumericStepper'
import { deleteFile } from '@/api/storage'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import * as DocumentSource from '@/class/cargo/model/parameters/DocumentSource'
import { execBatchSave, findBusinessDocument } from '@/api/seaExport/businessDocument'
import * as commonUtil from '@/utils/commonUtil'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import URL from '@/api/urlTranslator'

export default {
  name: 'SurchargeFclForm',
  components: {
    PairNumericStepper, CargoAgGrid, cargoAdvanceSelect, NumericStepper,
    cargoRichTextarea, cargoCloudFileUpload },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    isNew: {
      type: Boolean,
      default: () => false
    },
    sourcePrice: {
      type: Object,
      default: () => ({})
    },
    price: {
      type: Object,
      default: () => ({})
    },
    isCp: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      priceTypes: PriceConstant.PRICE_ALL_TYPES,
      chargeItems: [],
      chargeTypes: [], // 费用类型数据来源
      dangerousClassData: [],
      selectRow: null, // 选中的文件
      config: null,
      costVat: null,
      sellVat: null,
      file: {
        docType: [],
        fileName: '',
        fileIdList: '',
        storageURL: '',
        fileTypeMap: new Map(),
        cloudFile: {
          visible: false,
          lob: ''
        },
        rowData: [],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowClicked: this.onRowClickedEvent
        },
        gridParams: {},
        gridApi: null,
        columnDefs: [
          {
            headerName: this.$t('FileHistory.fileName'),
            field: 'fileName',
            width: 240, cellRenderer: (params) => {
              const url = `${URL.common.findByFileId}/${params.data.fileId}?sessionId=${this.$store.getters.token}`
              return `<a href="${url}" target="_blank" style="color:#1890ff">${params.value}</a>`
            }
          },
          {
            headerName: this.$t('FileHistory.jobType'),
            field: 'fileType',
            width: 200,
            cellRenderer: params => {
              return params.data.fileName.substring(params.data.fileName.lastIndexOf('.') + 1)
            }
          },
          {
            headerName: this.$t('FileHistory.fileSize'),
            field: 'fileSize',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.fileSizeColumnLabel(params.value)
            }
          }
        ]
      },
      directTypeList: PriceConstant.DIRECT_TYPE
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.selectRow = null
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    dangerousClass: {
      get() {
        return StrUtils.isEmpty(this.price.dangerousClass) ? [] : this.price.dangerousClass.split(',')
      },
      set(val) {
        this.price.dangerousClass = val.join(',')
      }
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    hasSelectFile() {
      return this.selectRow !== null
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.tenantUtil = await TenantUtil.getInstance()
      await cache.load(cacheName.CONFIG)
      this.config = cache.config
      this.file.storageURL = this.config.get('StorageURL')
      await getIMDGClassification({}).then((res) => {
        this.dangerousClassData = res.data
      })
      await this.initData()
    },
    onSubmit() {
      if (StrUtils.isEmpty(this.price.pol) && StrUtils.isEmpty(this.price.pod) && StrUtils.isEmpty(this.price.region)) {
        this.$message.warning(this.$t('Pricing.polOrPodOrRegionOneMustBeEntered'))
        return
      }
      if (this.verifyForm()) {
        return
      }
      if (this.price.directType === PriceConstant.TRANSIT_TO_PORT.code) {
        if (!StrUtils.isEmpty(this.price.via)) {
          if (this.verifySame('via', 'pol')) {
            return
          }
          if (this.verifySame('via', 'pod')) {
            return
          }
        }
      } else {
        this.price.via = ''
      }
      const isEQ = this.price.cost20 !== PriceConstant.NIL ||
        this.price.cost40 !== PriceConstant.NIL ||
        this.price.costhc !== PriceConstant.NIL ||
        this.price.cost45 !== PriceConstant.NIL ||
        this.price.cost20nor !== PriceConstant.NIL ||
        this.price.cost40nor !== PriceConstant.NIL
      const isCase = this.price.casePrice !== PriceConstant.NIL
      if (isEQ && isCase) {
        this.$message.warning(StrUtils.substitute(this.$t('Pricing.EXISTS_SAME_TIME2'), ["20',40',40'HC,45',20NOR,40NOR", this.$t('Pricing.UnitPrice')]))
        return
      }
      const valid20 = this.isLessThan('cost20', 'sum20')
      const valid40 = this.isLessThan('cost40', 'sum40')
      const validHC = this.isLessThan('costhc', 'sumhc')
      const valid45 = this.isLessThan('cost45', 'sum45')
      const valid20nor = this.isLessThan('cost20nor', 'sum20nor')
      const valid40nor = this.isLessThan('cost40nor', 'sum40nor')
      const validCasePrice = this.isLessThan('costCasePrice', 'casePrice')
      if (valid20 || valid40 || validHC || valid45 || validCasePrice || valid20nor || valid40nor) {
        this.$confirm(this.$t('Pricing.costAndSumInvalidSave'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(async() => {
          this.save()
        }).catch(() => {
          this.focusInput({ valid20, valid40, validHC, valid45, validCasePrice, valid20nor, valid40nor })
        })
      } else {
        this.save()
      }
    },
    focusInput(validArr) {
      const { $refs } = this
      for (const field in validArr) {
        if (validArr[field]) {
          $refs[field].$children[0].focus()
          return
        }
      }
    },
    isLessThan(cost, sum) {
      return this.price[cost] !== 0 && this.price[cost] !== PriceConstant.NIL && this.price[cost] > this.price[sum]
    },
    save() {
      if (!this.price.vat) {
        if (Number(this.price.sellVat) < Number(this.price.costVat)) {
          this.$message.warning(this.$t('Pricing.VatInvalid'))
          return
        }
      } else {
        this.price.costVat = 0
        this.price.sellVat = 0
      }
      if (this.price.beginDate > this.price.endDate) {
        this.$message.warning(this.$t('Pricing.CompareValidate'))
        return
      }
      let isUpdateState = false
      if (!this.isNew) {
        if (this.price.state === 1) {
          isUpdateState = true
          this.price.state = 0
        }
      }
      this.price.dangerousClass = this.dangerousClass.join(',')
      // 船公司
      if (!this.price.carrier) {
        this.price.carrier = 0
      }
      if (!this.price.bookingAgent) {
        this.price.bookingAgent = 0
      }
      this.price.branchId = this.$store.getters.currentOfficeId
      saveSurchargeFCL(this.price).then((res) => {
        commonUtil.objCopy(res.data, this.sourcePrice)
        if (this.isNew) {
          this.$message.success(this.$t('Pricing.SavedSucceed'))
        } else {
          if (isUpdateState) {
            this.$message.success(this.$t('Pricing.CurrentPriceEditSucceed'))
          } else {
            this.$message.success(this.$t('Pricing.SavedSucceed'))
          }
        }
        this.$emit('close')
        this.$emit('clearGrid')
      })
    },
    // 修改已发布运价后, 移除原有记录
    deleteCp(data) {
      const params = []
      params.push(data.uuid)
      this.$emit('deleteCp', params)
    },
    setDefaultValue(...fields) {
      fields.forEach(item => {
        if (!this.price[item]) {
          this.price[item] = ''
        }
      })
    },
    verifyForm() {
      for (const ref in this.$refs) {
        if (this.$refs[ref].isRequired && this.verifyField(ref)) {
          const label = this.$refs[ref].label
          const valid = this.$refs[ref].$attrs.valid
          if (valid) {
            this.$message.warning(valid + label)
            return true
          }
          this.$message.warning(label + this.$t('Pricing.WrongInput'))
          return true
        }
      }
    },
    verifyField(field) {
      if (typeof this.price[field] === 'number') {
        return this.price[field] === 0 && field !== 'freightType'
      }
      return StrUtils.isEmpty(this.price[field])
    },
    verifySame(field1, field2) {
      if (this.price[field1] === this.price[field2]) {
        const label1 = this.$refs[field1].label
        const label2 = this.$refs[field2].label
        const message = this.$t('Pricing.MustDifferent')
        this.$message.warning(message.replace('{0}', label1).replace('{1}', label2))
        return true
      }
      return false
    },
    onCancel() {
      this.$emit('close')
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0
      }
      this.advanceTextDialog.formatObj = formatObject ? { ...defaultFormatObj, ...formatObject } : defaultFormatObj
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    changeSurchargeScaleCode(p) {
      this.price.chargeScaleCode = p.value
      this.onSurchargeScaleCodeChanged()
    },
    async initData() {
      const chargeItems = await getSpecificBasicData(this.selectTypeNames.basic_data_ChargeItem)
      const localChargeItem = []
      if (chargeItems && chargeItems.length > 0) {
        for (const item of chargeItems) {
          if ((item.seaExport || item.seaImport) && (item.surcharge || item.localCharge || item.desCharge) && item.active) {
            localChargeItem.push(item)
          }
        }
      }
      this.chargeItems = localChargeItem
      // 加载费用类型
      this.onSurchargeScaleCodeChanged()
      // 加载附件
      this.price.documentType = DocumentSource.SURCHARGEFCL.chineseName
      this.toFileQuery()
      this.sellVatChange(this.price.sellVat)
      this.costVatChange(this.price.costVat)
    },
    async onSurchargeScaleCodeChanged() {
      if (this.price.chargeScaleCode) {
        const chargeItem = await ChargeItem.getChargeItemByScaleCode(this.price.chargeScaleCode)
        const source = []
        if (chargeItem) {
          if (chargeItem.surcharge) {
            source.push({ 'label': this.$t('Pricing.Surcharge'), 'value': 'S' })
          }
          if (chargeItem.localCharge) {
            source.push({ 'label': this.$t('Pricing.LocalCharge'), 'value': 'L' })
          }
          if (chargeItem.desCharge) {
            source.push({ 'label': this.$t('Pricing.DesCharge'), 'value': 'D' })
          }
        } else {
          source.push({ 'label': this.$t('Pricing.Surcharge'), 'value': 'S' })
          source.push({ 'label': this.$t('Pricing.LocalCharge'), 'value': 'L' })
          source.push({ 'label': this.$t('Pricing.DesCharge'), 'value': 'D' })
        }
        this.chargeTypes = source
        if (source.length === 1) {
          this.price.chargeType = source[0].value
        }
      } else {
        this.chargeTypes = []
      }
    },
    async delFileEventHandler() {
      this.$confirm(this.$t('Message.SureYouWantToDeleteFiles'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        // 调用后端删除api
        const data = {
          addItems: [],
          deleteItems: [this.selectRow.uuid]
        }
        const success = await deleteFile(this.selectRow.fileId).then(res => res.data)
        if (success !== 'success') {
          this.$message.warning(this.$t('Message.DeleteFailed'))
          return
        }
        execBatchSave(data).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_FDS'))
          this.toFileQuery()
        })
      }).catch(() => {
      })
    },
    fileUploadSuccess(rowData = []) {
      // 保存 文件数据
      if (rowData && rowData.length > 0) {
        const documents = []
        for (const data of rowData) {
          const doc = {}
          doc.fileName = data.fileName
          doc.fileSize = data.fileSize
          doc.fileType = data.fileType
          doc.documentCategory = DocumentSource.SURCHARGEFCL.code
          doc.fileCategory = 'other'
          doc.businessId = this.price.uuid
          doc.relationId = data.params.uuid
          doc.documentId = data.fileId
          doc.bytesLoaded = 0
          doc.bytesTotal = 100
          documents.push(doc)
        }
        // 调用后端保存api
        const data = {
          addItems: documents,
          deleteItems: []
        }
        execBatchSave(data).then(res => {
          this.toFileQuery()
        })
      }
    },
    toFileQuery() {
      if (this.isNew) {
        return
      }
      const item = { businessId: this.price.uuid, documentCategory: DocumentSource.SURCHARGEFCL.code }
      findBusinessDocument(item).then(res => {
        this.file.rowData = Array.from(res.data, p => {
          return {
            seq: p.uuid,
            uuid: p.uuid,
            fileId: p.documentId,
            fileName: p.fileName,
            fileType: p.fileType || '',
            fileSize: p.fileSize,
            createdBy: p.createdBy,
            dateCreated: p.dateCreated,
            documentId: p.documentId
          }
        })
      })
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.selectRow = data
    },
    costVatChange(newVal) {
      const val = Number(newVal)
      if (!val || val < 0) {
        this.costVat = null
        this.price.costVat = 0
        return
      }
      const formatNumber = this.$numeral(val).format('0.000')
      this.price.costVat = formatNumber
      this.costVat = formatNumber
    },
    sellVatChange(newVal) {
      const val = Number(newVal)
      if (!val || val < 0) {
        this.sellVat = null
        this.price.sellVat = 0
        return
      }
      const formatNumber = this.$numeral(val).format('0.000')
      this.price.sellVat = formatNumber
      this.sellVat = formatNumber
    }
  }
}
</script>

<style scoped>
</style>
<style lang="scss">
.surcharge-fcl-form-dialog{
  input[type="number"]{
    text-align: right;
  }
}
</style>
